import React from "react";
import { number, string } from "prop-types";
import { useTranslation } from "react-i18next";

import { Tooltip } from "~/components";
import { Container } from "./styles";

const RiskDot = ({ impactId, columnContent }) => {
  const { t } = useTranslation("components");

  const getImpactLevel = (id) => {
    switch (id) {
      case 1:
        return t("risks.low");
      case 2:
        return t("risks.medium");
      case 3:
        return t("risks.high");
      case 4:
        return t("risks.critical");
      default:
        return "Desconhecido";
    }
  };

  const safeColumnContent =
    typeof columnContent === "string"
      ? columnContent.trim() || "N/A"
      : columnContent || "N/A";

  const tooltipText = `${getImpactLevel(impactId)} - ${safeColumnContent}`;

  return (
    <Tooltip label={tooltipText}>
      <Container impactId={impactId} />
    </Tooltip>
  );
};

RiskDot.propTypes = {
  impactId: number.isRequired,
  columnContent: string.isRequired,
};

export default RiskDot;
